export default __webpack_public_path__ + "files/Senate Committee on Agriculture, Nutrition, and Forestry-26b04a7c553f90b0c82f4ae0389992b0.png";